<template>
  <el-dialog
    v-el-drag-dialog
    :title="$t('CargoMsg.Cargo_UpdateReceivedAmount')"
    :close-on-click-modal="false"
    :visible.sync="innerVisible"
    width="330px"
    @close="cancel"
  >
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form :inline="true" label-width="70px" label-position="left" @submit.native.prevent>
        <div style="margin-top: 10px;">
          <el-form-item :label="$t('CargoMsg.Cargo_ReceiptAmount')">
            <el-input-number v-model="receivedAmount" controls-position="right" style="width: 120px;" :precision="2" :step="1" :max="999999999999" />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="confirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { receivedAmount } from '@/api/clearing/ocPayment'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'UpdateReceivedAmountDialog',
  props: {
    visible: { type: Boolean, required: true },
    ocPayment: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      receivedAmount: 0,
      loading: null
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.receivedAmount = this.ocPayment.receivedAmount
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    confirm() {
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmOrNot') + '?', this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        this.ocPayment.receivedAmount = this.receivedAmount
        receivedAmount([this.ocPayment]).then(res => {
          this.$emit('success', res.data)
          this.innerVisible = false
          this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
        }).finally(() => {
          if (this.loading) {
            this.loading.close()
          }
        })
      })
    },
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
</style>
